import { TakerMarket } from '@/enterprise/data/useTakerMarkets';

const getTakerMarketDivisionTitle = (takerMarket: TakerMarket) => {
  const takerDivisionName = takerMarket.takerDivisionName ? takerMarket.takerDivisionName : null;
  const takerMakerId = takerMarket.takerMakerId ? takerMarket.takerMakerId : null;

  if (takerDivisionName && takerMakerId) {
    return {
      title: `${takerDivisionName} ⋅ ${takerMakerId}`,
      content: (
        <span className="space-x-0.5">
          <span>{takerDivisionName}</span>
          <span>&sdot;</span>
          <span>{takerMakerId}</span>
        </span>
      ),
    };
  } else if (takerDivisionName) {
    return {
      title: takerDivisionName,
      content: <span>{takerDivisionName}</span>,
    };
  } else if (takerMakerId) {
    return {
      title: takerMakerId,
      content: <span>{takerMakerId}</span>,
    };
  }
};

export default getTakerMarketDivisionTitle;
